import { alias, createModelSchema } from "serializr";
import { SmartOfferBundle } from "../bundle-core/SmartOfferBundle";
import { RewardBunch } from "@/modules/redactor/models/reward/RewardBunch";
import { SmartOfferBundleKind } from "../bundle-core/SmartOfferBundleKind";
import {Schema} from "@/common/Schema";

export class SmartOfferBundleOnePlusTwo extends SmartOfferBundle {

    constructor() {
        super(SmartOfferBundleKind.ONE_PLUS_TWO);

        this._product = null;
        this._rewards = null;
    }

    get product() {
        return this._product;
    }

    set product(value) {
        this._product = value;
    }

    get rewards() {
        return this._rewards;
    }

    set rewards(value) {
        this._rewards = value;
    }

    valid() {

        if (!this.product || this.product.length === 0) {
            return false;
        }

        if (this.rewards && !this.rewards.valid()) {
            return false;
        }

        return super.valid();
    }

    empty() {

        if (!this.product || this.product.length === 0) {
            return true;
        }

        if (!this.rewards || this.rewards.empty()) {
            return true;
        }

        return super.empty();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SmartOfferBundleOnePlusTwo());
        } else if (target instanceof SmartOfferBundleOnePlusTwo) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SmartOfferBundleOnePlusTwo, {
    _product: alias("product", Schema.primitive()),
    _rewards: alias("rewards", RewardBunch.schema()),
});
